import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { useShortcut } from "app/components/React/QuickSearch/hooks/useShortCut";
import { AI_SUPER_AGENT } from "app/pages/sales-intelligence/constants/routes";
import { isMac } from "app/UtilitiesAndConstants/UtilityFunctions/osDetection";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { superAgentSidebarButtonDataAutomation } from "./dataAutomation";
import * as SC from "./styles";
import superAgentSidebarButtonTracking from "./tracking";

type SuperAgentSidebarButtonProps = {
    isCollapsed: boolean;
};

export const SuperAgentSidebarButton = ({ isCollapsed }: SuperAgentSidebarButtonProps) => {
    const { translate } = useTranslate();
    const shortcutText = isMac() ? "⌘K" : "ctrl+k";

    const onButtonClick = useCallback(() => {
        superAgentSidebarButtonTracking.trackClickSidebarButton();
        void proNavigator.go(AI_SUPER_AGENT);
    }, []);

    useShortcut("k", onButtonClick);

    return (
        <SC.Wrapper
            isCollapsed={isCollapsed}
            onClick={onButtonClick}
            data-automation={superAgentSidebarButtonDataAutomation.button}
        >
            <SWReactIcons
                iconName="ai-search"
                size="xs"
                iconColor={colorsPalettes.carbon[300]}
            />

            <SC.Text
                isCollapsed={isCollapsed}
                data-automation={superAgentSidebarButtonDataAutomation.buttonText}
            >
                {translate("si.super-agent.sidebar.button")}
            </SC.Text>

            <SC.ShortCutWrapper
                isCollapsed={isCollapsed}
                data-automation={superAgentSidebarButtonDataAutomation.buttonShortCut}
            >
                {shortcutText}
            </SC.ShortCutWrapper>
        </SC.Wrapper>
    );
};
